import { Moment } from 'moment';

export const enum ScheduledPaymentFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY'
}

export const enum ScheduledPaymentStatus {
  ACTIVE = 'ACTIVE',
  STOPPED = 'STOPPED',
  SUSPENDED = 'SUSPENDED'
}

export interface IScheduledPayments {
  id?: number;
  fromAccount?: string;
  toAccount?: string;
  amount?: number;
  frequency?: ScheduledPaymentFrequency;
  startDate?: Moment;
  endDate?: Moment;
  occurences?: number;
  status?: ScheduledPaymentStatus;
  dateCreated?: Moment;
  dateUpdated?: Moment;
  institutesName?: string;
  institutesId?: number;
  bankingUserProfileId?: number;
}

export const defaultValue: Readonly<IScheduledPayments> = {};
